// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDjGv7no5rRRiQz8iavEF83at7QoLG6i_Y",
  authDomain: "dark-bit-457311-p5.firebaseapp.com",
  projectId: "dark-bit-457311-p5",
  storageBucket: "dark-bit-457311-p5.firebasestorage.app",
  messagingSenderId: "1004977044339",
  appId: "1:1004977044339:web:78286999b303f5f3572306",
  measurementId: "G-7B0BQZPWSK"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// Optional: For debugging in browser console
window.firebaseApp = app;
window.firebaseAuth = auth;